<mat-card>
	<mat-card-header>
		<mat-card-title>
			Update existing school enrollments for {{students ? students.length: ''}} Child Enrollments
			<mat-icon *ngIf="isLoading">
				<mat-spinner diameter="20"> </mat-spinner>
			</mat-icon>
		</mat-card-title>
		<button class="close-button" mat-mini-fab (click)="closeDialog(false)">
			<mat-icon>close</mat-icon>
		</button>
	</mat-card-header>

	<mat-card-content>
		<div class="padding-vertical-md" *ngIf="!isLoading">
			<form [formGroup]="form" (ngSubmit)="submit()" #enrollmentForm="ngForm">
				<div>
					<div class="row">
						<div class="col-lg-6" [hidden]="true">
							<div class="row">
								<app-school-year class="col" [label]="'School Year'" [yearType]="'SchoolYear'"
									(performancePeriodEvent)="schoolYearEvent($event)" [currentYearModifier]="0"
									[yearsBack]="1" [yearsForward]="1" [reset]="resetField"
									[selectSchoolYear]="selectSchoolYear" [required]="false">
								</app-school-year>
							</div>
						</div>

						<div class="col-lg-6">
							<div class="row">
								<mat-form-field class="col">
									<mat-label>
										Enrollment Date Type
									</mat-label>
									<mat-select formControlName="fieldToUpdate"
										(selectionChange)="fieldToUpdateChange($event)">
										<mat-option *ngFor="let fieldToUpdate of fieldsToUpdate"
											[value]="fieldToUpdate">
											{{fieldToUpdate}}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
						</div>
						<div class="col-lg-6" [hidden]="this.form.get('fieldToUpdate')?.value !== 'Withdrawal Date'">
							<div class="row">
								<mat-form-field class="col">
									<mat-label>
										Withdrawal Date
									</mat-label>
									<input matInput formControlName="dateToUpdate"
										[matDatepicker]="withdrawalDatePicker" (click)="withdrawalDatePicker.open()"
										startView="multi-year" [min]="withdrawalDateOptions.minDate"
										[max]="withdrawalDateOptions.maxDate">
									<mat-datepicker-toggle matSuffix
										[for]="withdrawalDatePicker"></mat-datepicker-toggle>
									<mat-datepicker #withdrawalDatePicker startView="multi-year"
										[startAt]="withdrawalDatePicker.startAt"></mat-datepicker>
								</mat-form-field>
							</div>
						</div>
					</div>


					<div class="row" *ngIf="mixedEnrollmentTypes">
						<div class="col danger bold">
							Mixed Enrollment Types Detected. (<span
								*ngFor="let key of requiresEnrollmentTypesKeys; let first = first;">
								<span [hidden]="first">, </span>{{key}}: {{requiresEnrollmentTypes[key].count}}</span>)
						</div>
					</div>

					<div class="row" *ngIf="dateFlags.length > 0">
						<div class="col">
							<div class="warn-font-color italic" *ngFor="let dateFlag of dateFlags">
								{{dateFlag.MIN_MAX}} {{dateFlag.DATE_TYPE}} date is set to {{dateFlag.DATE |
								simpleDate}} due to
								{{dateFlag.NAME | titlecase}}'s
								<span *ngIf="dateFlag.MSD_NUMBER.length > 0">({{dateFlag.MSD_NUMBER}}) </span>
								<span *ngIf="dateFlag.MIN_MAX == 'Minimum' && !dateFlag.ENDING_TYPE">earliest</span>
								<span *ngIf="dateFlag.MIN_MAX == 'Maximum' && !dateFlag.ENDING_TYPE">latest</span>
								{{dateFlag.TYPE}} date.
							</div>
						</div>
					</div>

					<div class="row" *ngIf="dateFlags.length > 0">
						<div class="col">
							<div class="danger bold" *ngFor="let creationFlag of creationFlags">
								{{creationFlag.NAME | titlecase}}'s
								<span *ngIf="creationFlag.MSD_NUMBER.length > 0">({{creationFlag.MSD_NUMBER}})</span>
								{{creationFlag.TYPE}} date {{creationFlag.DATE | simpleDate}}
								is ineligiblity for School Year {{selectedSchoolYear}}.
							</div>
						</div>
					</div>

				</div>
			</form>

			<hr />

			<mat-card-actions class="inline">
				<confirm-popover class="margin-bottom-xs" [buttonType]="'string'" [color]="'primary'"
					[popoverMsg]="'Confirm Update'" [popoverConfirmText]="'Update'" [buttonTxt]="'Update'"
					[popoverConfirmColor]="'primary'" (onConfirm)="submit()"
					[disabled]="mixedEnrollmentTypes || isSubmitting || (msg && msg.SUCCESS!)">
				</confirm-popover>

				<button type="button" mat-icon-button *ngIf="isSubmitting">
					<mat-icon>
						<mat-spinner diameter="20"> </mat-spinner>
					</mat-icon>
				</button>
				<app-msg class="margin-left-sm" [msg]="msg" *ngIf="msg?.MSG"></app-msg>
			</mat-card-actions>
		</div>
	</mat-card-content>
</mat-card>